import type { IngredientSlice, IngredientActions } from '@/types/store';
import type { ParseResult } from '@allergen-lens/shared-logic';
import type { SliceSet } from './types';
import { parseIngredients } from '@allergen-lens/shared-logic';

type Slice = IngredientSlice & IngredientActions;

export const createIngredientSlice = (
  set: SliceSet
): Slice => ({
  rawInput: '',
  tokens: [],
  parseError: null,

  setRawInput: (input: string) => {
    const result: ParseResult = parseIngredients(input);
    set(() => ({
      rawInput: input,
      tokens: result.tokens,
      parseError: result.error,
    }));
  },

  addManualIngredient: (name: string) => {
    set((state) => {
      const newInput = state.rawInput ? `${state.rawInput}, ${name}` : name;
      const result: ParseResult = parseIngredients(newInput);
      return {
        rawInput: newInput,
        tokens: result.tokens,
        parseError: result.error,
      };
    });
  },

  removeToken: (tokenId: string) => {
    set((state) => {
      const remaining = state.tokens.filter((t) => t.id !== tokenId);
      const newInput = remaining.map((t) => t.rawText).join(', ');
      return {
        rawInput: newInput,
        tokens: remaining,
      };
    });
  },
});
